import { Col, Container, Row, Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { validateService } from "../service/validation.service";
import { apiService } from "../service/api.service";
import Loader from "../common/Loader";
import {PasswordRegex} from "../config/config"
import swal from "sweetalert";
const SignUp = () => {
  let history = useNavigate();
  function CreateProfile() {
    window.location.href = "/create-profile"
    // history("/create-profile");
  }
  const [loader, setLoader] = useState(false)
  const [showPass,setshowPass]=useState(false)
  const [showPassConfirm,setshowPassConfirm]=useState(false)
  const [registerFields, setregisterFields] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    role: "cultivator",
    terms_and_conditions:false

  });
  const [registerFieldsErrs, setregisterFieldsErrs] = useState({
    email: "",
    password: "",
    cpassword: "",
    terms_and_conditions:""
  });
  const onInputChange = (field, value) => {
    if(field=="password"){
      checkPasswordStrngth(value)
        setregisterFields({
          ...registerFields,
          [field]: value,
        });
      
      
    }else{
      setregisterFields({
        ...registerFields,
        [field]: value,
      });
    }
   

  };
  const handleSubmit = () => {

    // e.preventDefault();

    let formValidated = validateService.register(setregisterFieldsErrs, registerFields)
    console.log(registerFieldsErrs)
    if (formValidated) {
      setLoader(true)
      apiService.signup(registerFields).then((res) => {
        setregisterFields({
          email: "",
          password: "",
          confirmPassword: "",
          role: "cultivator",
        });
        setregisterFieldsErrs({
          email: false,
          emailErr: "",
          password: false,
          passwordErr: "",

        });
        setLoader(false)
        console.log(res.data)
        localStorage.setItem("web_token", res.data.data.token)
        localStorage.setItem("user", res.data.data.user.id)

        CreateProfile()
      })
        .catch((err) => {
          swal("Error",err.response.data.message,"error")
          // if(err.response.data.message=="Please Verify your email first"){

          // }   setLoader(true)
          console.log(err)

          setLoader(false)

          console.log("contact us api error", err.response);
        });
    }


  }
  const checkPasswordStrngth = (val)=>{
    if(PasswordRegex.test(val)){
      setregisterFieldsErrs({
        ...registerFieldsErrs,
        "password": "",
      });
      return true

    }else{
      setregisterFieldsErrs({
        ...registerFieldsErrs,
        "password": "Password must be a minimum of 8 characters and include at least one uppercase letter, one lowercase letter, one number, and one special character. ",
      });
    }
    return false
  }

  return (
    <>
      <section className="login-section">
        {loader && <Loader />}
        <Container>
          <Row>
            <Col lg={6} md={8}>
              <div className="login-form-box">
                <div className="login-header">
                  <h2>Sign Up </h2>
                  <p>Use email address and password.</p>
                </div>
                <Form className="login-body">
                  <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control type="email" placeholder="Enter Email Address"
                      onChange={(e) => onInputChange("email", e.target.value)}

                    />
                    <span className="text-danger">{registerFieldsErrs.email}</span>
                  </Form.Group>
                  <Form.Group className="mb-3 position-relative">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type={showPass?"text":"password"} placeholder="Enter Password"
                      onChange={(e) => onInputChange("password", e.target.value)}

                     
                    />
                   {showPass?
                    <img
                    className="eye-icon"
                    src={require("../assets/images/eye-crossed 1.svg").default}
                    onClick={()=>setshowPass(false)}
                    alt="img"
                  /> :
                    <img
                      className="eye-icon"
                      onClick={()=>setshowPass(true)}
                      src={require("../assets/images/eye (1).svg").default}
                      alt="img"
                    />
                    }
                    <span className="text-danger">{registerFieldsErrs.password}</span>
                  </Form.Group>
                  <Form.Group className="mb-3 position-relative">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control type={showPassConfirm?"text":"password"} placeholder="Enter Password"
                      onChange={(e) => onInputChange("confirmPassword", e.target.value)}
                    />
                      {showPassConfirm?
                    <img
                    className="eye-icon"
                    src={require("../assets/images/eye-crossed 1.svg").default}
                    onClick={()=>setshowPassConfirm(false)}
                    alt="img"
                  />:
                    <img
                      className="eye-icon"
                      onClick={()=>setshowPassConfirm(true)}
                      src={require("../assets/images/eye (1).svg").default}
                      alt="img"
                    />}
                    <span className="text-danger">{registerFieldsErrs.cpassword}</span>
                  </Form.Group>
                  <Form.Group className="mb-4" controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" label={
                      <>
                        <span>I accept the <a className="terms-condition" href="/#" target="_blank">Terms & Conditions</a>.</span>
                      </>
                    }
                      onChange={(e) => {
                        setregisterFields((prevObj) => {
                          return {
                            ...prevObj,
                            terms_and_conditions: e.target.checked
                          };
                        });
                      }}
                    />
                   <span className="text-danger">{registerFieldsErrs.terms_and_conditions}</span>
                  </Form.Group>
                  <Button onClick={handleSubmit} className="green-btn">Sign Up</Button>
                  <p>Already have an account? <Link to="/login" className="">Sign In</Link></p>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default SignUp;
